<template>
    <div class="info-view right_auth">
        <div class="top">
            <div class="left">
                <p class="money">余额： <span>{{remaindAmount}}</span>元</p>
                <p class="remind">为了保证您账户的安全，请不要轻易相信他人要您提供账号信息，如有疑问请联系客服</p>
            </div>
            <div class="right btn">
                <button @click="$router.push({name:'RechargeView'})">充值</button>
            </div>
        </div>
        <div class="bottom">
            <div class="form_modal left">
                <i class="close"></i>
                <div class="form_ctr" :class="{'invalid':!param.ordinaryName}">
                    <label class="req">姓名</label>
                    <input type="text" class="short" v-model="param.ordinaryName">
                    <p class="error">请填写姓名</p>
                </div>
                <div class="form_ctr" :class="{'invalid':!param.userPetname}">
                    <label class="req">昵称</label>
                    <input type="text" class="short" v-model="param.userPetname">
                    <p class="error">请填写昵称</p>
                </div>
                <div class="form_ctr" :class="{'invalid':!param.ordinarySex}">
                    <label class="req">性别</label>
                    <label class="radio" v-for="item in [{id:1,label:'男'},{id:2,label:'女'},{id:3,label:'保密'}]">
                        <input type="radio" name="sex" :value="item.id" v-model="param.ordinarySex"> {{item.label}}
                    </label>
                    <p class="error">请选择性别</p>
                </div>
                <!--<div class="form_ctr">-->
                    <!--<label class="">生日</label>-->
                    <!--<input type="text" class="short" v-model="param.ordinaryBirthday">-->
                    <!--<p class="error"></p>-->
                <!--</div>-->
                <div class="form_ctr">
                    <label class="">兴趣爱好</label>
                    <input type="text" class="long" v-model="param.tag">
                    <p class="error"></p>
                </div>
                <div class="form_ctr">
                    <label class="">地址</label>
                    <input type="text" class="long" v-model="param.ordinaryAddress">
                    <p class="error"></p>
                </div>
                <div class="form_ctr">
                    <label class="">备用联系人</label>
                    <input type="text" class="long" v-model="param.backupName">
                    <p class="error"></p>
                </div>
                <!-- <div class="form_ctr">
                    <label class="req">备用联系电话</label>
                    <input type="text" class="long" v-model="param.backupPhone">
                    <p class="error"></p>
                </div> -->
                <div class="form_ctr">
                    <label class="">公司名称</label>
                    <input type="text" class="long" v-model="param.companyName">
                    <p class="error"></p>
                </div>
                <!-- <div class="form_ctr">
                    <label class="req">邮箱</label>
                    <input type="text" class="long">
                    <p class="error"></p>
                </div> -->
                <div class="form_ctr">
                    <label class="req">余额短信提示</label>
                    <label class="radio" v-for="item in [{id:1,label:'开启'},{id:2,label:'关闭'}]">
                        <input type="radio" name="message" :value="item.id" v-model="param.isSendSMS">{{item.label}}
                    </label>
                    <p class="error"></p>
                </div>
                <!--<div class="form_ctr">-->
                    <!--<label class="req left">推荐注册链接</label>-->
                    <!--<input class="clip_text" type="text" :value="'http://www.sd235.net/reset/register.html?vcode='+param.recommendCode" id="clip">-->
                    <!--&lt;!&ndash;<p class="chain left">{{'http://new.sd235.net/view/reset/register.html?vcode='+param.recommendCode}}</p>&ndash;&gt;-->
                    <!--<button class="copy left" ref="copy" data-clipboard-target="#clip" @click="copy">复制链接</button>-->
                    <!--<button class="sum left" @click="recommend">推荐统计</button>-->
                <!--</div>-->
                <ul class="btn" style="margin-top: 50px;">
                    <li @click="submit()">提交</li>
                    <li @click="setParam()">重置</li>
                </ul>
            </div>
            <div class="avatar">
                <p class="left" style="font-size: 14px;">头像</p>
                <div class="wrap">
                    <img v-if="userHead" :src="userHead" alt="">
                    <!-- <img src="../assets/img/paywx_er.png" alt=""> -->
                </div>
                <button @click="doUpload">上传头像</button>
            </div>
        </div>
        <sd-upload ref="upload" @on-upload="onUpload"></sd-upload>
        <sd-modal v-show="recommendSum.sum">
            <div class="sum_wrap">
                <p class="title">返利总额: <span>{{recommendSum.valueOne}}</span> 元</p>
                <i class="close" style="cursor: pointer" @click="recommendSum.sum = false"></i>
                <div class="content">
                    <ul>
                        <li>未处理的钱：<span>{{recommendSum.valueTwo}}</span>元</li>
                        <li>已处理的钱：<span>{{recommendSum.valueThree}}</span>元</li>
                        <li>已推荐：{{recommendSum.valueFour+recommendSum.valueFive}}人</li>
                        <!-- <li>已返利：{{recommendSum.valueOne}}元</li> -->
                    </ul>
                </div>
            </div>
        </sd-modal>
    </div>
</template>
<script type="es6">
  import { mapState, mapActions , mapGetters} from 'vuex'
  import sdUpload from '../components/sdUpload'
  import { util } from '../service/util'
  import Clipboard from 'clipboard'
  import sdModal from '../components/sdModal'

  let API = util.api([
      'SEARCHCUSTOMERAMOUNT', // 获取余额
      'UPDATEMYINFO',         // 更新信息
      'GETRETURNCASHINFO'
    ])
    export default {
      name: 'info-view',
      components: { sdUpload,sdModal},
      data () {
        return {
          recommendSum:{
              sum:false,
              valueOne:0,
              valueTwo:0,
              valueThree:0,
              valueFour:0
          },
          remaindAmount: 0,
          param: {
                "ordinaryName":"",
                "ordinarySex":"",
                "ordinaryBirthday":"",
                "tag":"",
                "ordinaryAddress":"",
                "backupName":"",
                "backupPhone":"",
                "companyName":"",
                "userPetname":"",
                "userHead":"",
                "userMail":""
          },
          userHead: '',
        }
      },
      computed: {
        ...mapState({
            userInfo : state => state.common.userInfo,
            log : state => state.common.log
          }),
      },
      methods: {
        // 执行上传
        doUpload() {
            this.$refs.upload.doUpload();
        },
        // 上传成功
        onUpload(data, file) {
            // 赋值
            this.param.userHead = data.data;
            // 预览
            this.userHead = util.preImgPath(data.data);
        },
        // 重置
        setParam() {
            this.$store.dispatch('getUserInfo')
            .then( res => {
                this.param = {...this.param, ...util.copy(this.userInfo)};
                this.userHead = util.imgPath(this.param.userHead);
            })
        },
        // 提交
        submit() {
            let param = util.copy(this.param);
            if(!param.ordinaryName || !param.ordinarySex || !param.userPetname){
                util.confirm.error('请完善必填信息！');
                return;
            }
            util.kAjax(API.UPDATEMYINFO, param, res => {
                util.confirm.success('更新信息成功！');
                this.$store.dispatch('getUserInfo');
            })
        },
        // 复制成功提示
        copy(){
            util.confirm.success('已复制到剪切板！')
        },
        // 推荐统计
        recommend(){
            let _this = this;
            util.kAjax(API.GETRETURNCASHINFO,{},res=>{
                _this.recommendSum = {
                    ..._this.recommendSum,
                    ...res.data
                };
                _this.recommendSum.sum = true;
            })
        }
      },
      created() {
        // 从用户信息获取
        this.setParam();
        util.kAjax(API.SEARCHCUSTOMERAMOUNT, {}, res => {
            this.remaindAmount = res.data;
        })
      },
      mounted(){
        let a = this.$refs.copy;
        new Clipboard(a)
      }
    }
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// InfoView.vue?18ebe202